import { Spinner } from "flowbite-react";
import { useState, useEffect } from "react";
import { useIntegrations } from "../../../../contexts/IntegrationsContext";
import { PostHogHeader } from "./PostHogHeader";
import { PostHogCredentialsForm } from "./PostHogCredentialsForm";
import { UsageMetricsForm } from "../shared/UsageMetricsForm";

export const PostHogIntegration = () => {
  const { loading, isIntegrationConnected, getIntegrationById } =
    useIntegrations();

  const [credentials, setCredentials] = useState({
    api_key: "",
    project_id: "",
  });

  const isConnected = isIntegrationConnected("posthog");
  const integration = getIntegrationById("posthog");

  useEffect(() => {
    if (isConnected) {
      setCredentials({ api_key: "", project_id: "" });
    }
  }, [isConnected]);

  if (loading) {
    return (
      <div className="flex h-48 items-center justify-center">
        <Spinner size="lg" aria-label="Loading PostHog integration" />
      </div>
    );
  }

  return (
    <div className="flex min-h-full flex-1 flex-col gap-4">
      <div className="animation-slide-up-lil-bounce mt-1 flex w-full flex-col gap-4 overflow-x-auto rounded-lg bg-white py-4 shadow">
        <PostHogHeader
          isConnected={isConnected}
          integration={integration}
          credentials={credentials}
        />

        {!isConnected && (
          <>
            <hr className="border-gray-200" />
            <PostHogCredentialsForm
              credentials={credentials}
              onCredentialsChange={setCredentials}
            />
          </>
        )}

        {isConnected && (
          <>
            <hr className="border-gray-200" />
            <UsageMetricsForm
              integration={integration}
              providerName="PostHog"
            />
          </>
        )}
      </div>
    </div>
  );
};
